import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input, OnChanges } from '@angular/core';

import { ScoreboardFactory } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { CompetitionLogoComponent, CompetitionLogosService } from '@frontend/sports/competition-logos/feature';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';

import { FavouriteEventToggleComponent } from '../../favourites/toggle/favourite-event-toggle.component';

@Component({
    selector: 'ms-prematch-tournament-scoreboard',
    templateUrl: 'prematch-tournament-scoreboard.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [DatePipe, CompetitionLogoComponent, ParticipantImageComponent, FavouriteEventToggleComponent],
})
export class PrematchTournamentScoreboardComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() isNewEDPScoreboard = false;
    @HostBinding('class') className = 'prematch-tournament';
    showCompetitionLogo = false;
    showDate = '';

    constructor(
        private scoreboardFactory: ScoreboardFactory,
        private competitionLogoService: CompetitionLogosService,
    ) {}

    ngOnChanges(): void {
        this.showDate = this.scoreboardFactory.showDate(this.event);
        this.showCompetitionLogo = !!this.event.league.imageProfile && this.competitionLogoService.hasLogo(this.event.sport.id, this.event.league.id);
    }
}
